export default __webpack_public_path__ + "static/media/jne.6d0b224a.png";